import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=40e860dd&scoped=true"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseSelect.vue?vue&type=style&index=0&id=40e860dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e860dd",
  null
  
)

export default component.exports